import _ from "lodash";
import { Timeline, Panel, Icon, IconButton, Carousel, Divider } from "rsuite";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { TranslationContext } from "../../umbilical_tools";
import jssVariables from "../../jss_setup";
import {
  getAddOnImgs,
  getAddOnItemImgs,
} from "../ListProduct/ProductStaticPkg";

const eventStyles = createUseStyles({
  event: {
    position: "fixed",
    left: 0,
    top: 0,
    height: "100vh",
    width: "100%",
    zIndex: 9999,
    background: jssVariables.colors.background.light,
    display: "grid",
    alignContent: "center",
    justifyContent: "center",
  },
  panel: {
    "width": "90%",
    "marginLeft": "5%",
    "maxHeight": "95vh",
    "overflow": "hidden",
    "display": "grid",
    "gridTemplateRows": "auto 1fr",
    "& .rs-panel-heading": {
      borderBottom: `2px solid ${jssVariables.colors.base_color}`,
      padding: jssVariables.normal_gap,
    },
    "& .rs-panel-body": {
      display: "grid",
      gridGap: jssVariables.normal_gap,
      gridGemplateRows: "1fr auto",
      overflow: "hidden",
    },
  },
  content: {
    "display": "grid",
    "gridGap": jssVariables.normal_gap,
    "overflow": "auto",
    "& .rs-timeline-item-dot": {
      "&:before": {
        backgroundColor: jssVariables.colors.base_color,
      },
    },
  },
  timelineImg: {
    width: `calc(${jssVariables.normal_gap} * 8)`,
    height: `calc(${jssVariables.normal_gap} * 8)`,
    objectFit: "cover",
    borderRadius: "50%",
    marginRight: jssVariables.normal_gap,
  },
  divider: {
    margin: jssVariables.normal_gap,
    backgroundColor: jssVariables.colors.base_color,
  },
  carouselImg: {
    objectFit: "cover",
    height: "100%",
    width: "100%",
  },
  actions: {
    display: "grid",
  },
  [`@media ${jssVariables.media.smallscreen}`]: {
    panel: {
      width: "30%",
      marginLeft: "35%",
      maxHeight: "80vh",
    },
    actions: {
      justifyItems: "end",
    },
  },
});

const EventDetails = (props) => {
  const { dayByDayData, dayIdx, uid, srvType, handleHideEventDetails } = props;
  const classes = eventStyles();
  const { t } = useContext(TranslationContext);

  const addon = _.get(dayByDayData, `${dayIdx}.${srvType}`, []).find(
    (srv) => srv.search_uid === uid
  );

  var imgs = getAddOnImgs(addon);
  if (!imgs.length) {
    imgs = getAddOnImgs(addon, { include_items: true });
  }

  return (
    <div className={classes.event}>
      <Panel
        className={classes.panel}
        shaded
        header={
          <h5>
            <Icon icon="map-marker" size="2x" /> {addon.title}
          </h5>
        }>
        <div className={classes.content}>
          <Carousel placement="top" shape="bar">
            {imgs.map((img, idx) => (
              <img className={classes.carouselImg} key={idx} alt="" src={img} />
            ))}
          </Carousel>
          <Divider className={classes.divider} />
          <p
            dangerouslySetInnerHTML={{
              __html: addon.general_description.description_en,
            }}></p>
          <Timeline>
            {addon.items.map((item, idx) => {
              const imgs = getAddOnItemImgs(item);
              const img = _.get(imgs, 0);

              return (
                <Timeline.Item key={idx}>
                  <img className={classes.timelineImg} alt="" src={img} />
                  <span>
                    <strong>{item.data.name_en}</strong>
                  </span>
                  <Divider className={classes.divider} />
                  <p
                    dangerouslySetInnerHTML={{ __html: item.description_en }}
                  />
                </Timeline.Item>
              );
            })}
          </Timeline>
        </div>
        <Divider />
        <div className={classes.actions}>
          <IconButton
            icon={<Icon icon="close" />}
            appearance="primary"
            onClick={handleHideEventDetails}>
            {t("close")}
          </IconButton>
        </div>
      </Panel>
    </div>
  );
};

EventDetails.propTypes = {
  dayByDayData: PropTypes.object.isRequired,
  dayIdx: PropTypes.number.isRequired,
  uid: PropTypes.string.isRequired,
  srvType: PropTypes.string.isRequired,
  handleHideEventDetails: PropTypes.func.isRequired,
};

export default EventDetails;
